import { MenuItem } from '@affine/core/modules/app-sidebar/views';
import { NotificationCountService } from '@affine/core/modules/notification';
import { useI18n } from '@affine/i18n';
import { NotificationIcon } from '@blocksuite/icons/rc';
import { useLiveData, useService } from '@toeverything/infra';
import type { ReactElement } from 'react';

import { NotificationListPopover } from '../notification/popover';
import * as styles from './notification-button.style.css';

const Badge = ({ count, onClick }: { count: number; onClick?: () => void }) => {
  if (count === 0) {
    return null;
  }
  return (
    <div className={styles.badge} onClick={onClick}>
      {count > 99999 ? '99999+' : count}
    </div>
  );
};

const NotificationButtonPostfix = ({
  count,
  postfix,
}: {
  count: number;
  postfix?: ReactElement;
}) => {
  const badge = <Badge count={count} />;
  if (!postfix) {
    return badge;
  }
  return (
    <div className={styles.postfixGroup}>
      {badge}
      {postfix}
    </div>
  );
};

export const NotificationButton = ({ postfix }: { postfix?: ReactElement }) => {
  const notificationCountService = useService(NotificationCountService);
  const notificationCount = useLiveData(notificationCountService.totalCount$);

  const t = useI18n();

  return (
    <NotificationListPopover>
      {open => (
        <MenuItem
          icon={<NotificationIcon />}
          postfix={
            <NotificationButtonPostfix
              count={notificationCount}
              postfix={postfix}
            />
          }
          active={open}
          postfixDisplay="always"
        >
          <span data-testid="notification-button">
            {t['com.streamlain.rootAppSidebar.notifications']()}
          </span>
        </MenuItem>
      )}
    </NotificationListPopover>
  );
};
